import React, { Component } from "react";
import style from "./list.module.sass";
import { Icon, Spin, Table } from "antd";
import { ReactComponent as TableEdit } from '../../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg'
import Bpmn from "./Bpmn";
import moment from 'moment';
import { connect } from "react-redux";
import { deleteForm } from "../../../../stateManager/store/forms/action";
import { Http } from "../../../../helpers/axois";
import { ReactComponent as BpmIllustration } from '../../../../assets/svg/bpm_illustration.svg'
import NoData from '../../NoData'
import { Button, Modal } from '../../../../helpers/commonUi'
import { IBpmnList, IsoloList } from './Ibpmn'
import { selectedSolo, selectedJourney } from '../../../../stateManager/store/solo/action';
import { setStepIndex, setGuideVisible } from '../../../../stateManager/store/onboarding/action'
import { pushToast } from '../../../../stateManager/store/toast/actions'
// import moment from 'moment'
import publicIcon from "../../../../assets/svg/solo/public_col_ico.svg"
import privateIcon from "../../../../assets/svg/solo/private_col_ico.svg"
// {moment(data.updated_at).format("DD-MM-YYYY")}
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { AppState } from "../../../../stateManager/store";
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";

interface State {
  visible: boolean;
  editInitialData?: {};
  editSoloData?: {};
  formsList?: any[];
  editable: boolean;
  editvisible?: boolean;
  editSolo: boolean;
  BpmnLoading: boolean;
  BpmnList: IBpmnList[];
  soloList: IsoloList[];
  [key: string]: any;
  deleteVisible: boolean;
  deleteData: any;
  editType: string;
  filteredData: any[];
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
}

interface Props {
  match?: any;
  app?: any;
  history?: any;
  selectedSolo?: any;
  selectedJourney?: any;
  deleteForm: (data: any) => void;
  appVersion?: { currentVersion: boolean, versionId: string };
  currentBranch?: any;
  pushToast: (data: any) => void;
  orgPermissions: any;
  appPermissions: any;
  setStepIndex: any;
  onboardingInfo: any;
  guideVisible: boolean;
  setGuideVisible: (data: boolean )=> void;
}

class FormsList extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      editInitialData: {},
      editable: false,
      BpmnList: [],
      editvisible: false,
      BpmnLoading: false,
      deleteVisible: false,
      soloList: [],
      deleteData: {},
      editSoloData: {},
      editSolo: false,
      editType: "",
      filteredData: [],
      searchValue: "",
      searchRef: React.createRef()
    };
  }

  componentDidMount() {
    this.getBpmns(this.props);
    // this.getSolo(this.props)

  }

  componentWillReceiveProps(props: Props) {
    if (props.appVersion !== this.props.appVersion) {
      this.getBpmns(props)
      // this.getSolo(props)
    }
  }

  getBpmns(props: Props, guideVisible?: any) {
    this.state.searchRef.current?.clearSearch()
    this.setState({ BpmnLoading: true })
    const appId = this.props.match.params.appId
    const versionId = props.appVersion && props.appVersion.versionId;
    if (versionId) {
      Http.get(`/apps/${appId}/bpmn?versionId=${versionId}`).subscribe((formRes: any) => {
        this.setState({
          BpmnList: formRes,
          filteredData: formRes,
          BpmnLoading: false
        })
        if (guideVisible) {
           setTimeout(()=>{
            this.props.setStepIndex(this.props.onboardingInfo.stepIndex + 1)
           },100)
        }
      }, (err: any) => {
        this.setState({
          filteredData: [],
          BpmnLoading: false
        })
      });
    }
  }

  // getSolo(props: Props) {
  //   this.setState({ BpmnLoading: true })
  //   const appId = this.props.match.params.appId
  //   const versionId = props.appVersion && props.appVersion.versionId;
  //   if (versionId) {
  //     Http.get(`/apps/${appId}/solo-flows?versionId=${versionId}`).subscribe((formRes: any) => {
  //       this.setState({
  //         soloList: formRes.flows,
  //         BpmnLoading: false
  //       })
  //     }, (err: any) => {
  //       this.setState({
  //         BpmnLoading: false,
  //         soloList: []
  //       })
  //     });
  //   }
  // }

  deleteAssist(bpmnId: string) {
    const appId = this.props.match.params.appId
    Http.delete(`/bpmn/${bpmnId}?appId=${appId}`).subscribe((res) => {
      this.props.pushToast(
        { type: 'success', message: 'Journey deleted successfully' }
      )
      this.getBpmns(this.props);
    }, (err) => {
      this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'Journey deletion failed' }
      )
    })
  }


  // deleteSolo(id: string) {
  //   const appId = this.props.match.params.appId;
  //   const versionId = this.props.appVersion && this.props.appVersion.versionId;
  //   const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
  //   Http.delete(`apps/${appId}/solo-flows/${id}?versionId=${versionId}&branchId=${currentBranchId}`).subscribe((res) => {
  //     this.props.pushToast(
  //       { type: 'success', message: 'Journey deleted successfully' }
  //     )
  //     this.getSolo(this.props);
  //   }, (err) => {
  //     this.props.pushToast(
  //       { type: 'error', message: (err && err.message) ? err.message : 'Journey deletion failed' }
  //     )
  //   })
  // }
  // content = (bpmn: any) => {
  //   return (
  //     <div>
  //       <p data-test-id="bpmn_edit"
  //         style={{ cursor: "pointer" }}
  //         onClick={e => {
  //           this.setState({

  //             [bpmn.bpmnId]: false
  //           });

  //           e.stopPropagation();
  //           this.setState({
  //             editvisible: true,
  //             editInitialData: bpmn,
  //             editable: true
  //           });
  //         }}
  //       >
  //         Edit
  //       </p>
  //       <p data-test-id="bpmn_delete"
  //         style={{ cursor: "pointer" }}
  //         onClick={e => {
  //           e.stopPropagation();
  //           this.setState({
  //             [bpmn.bpmnId]: false
  //           });
  //           this.deleteForms(bpmn.bpmnId)

  //         }}
  //       >
  //         Delete
  //       </p>
  //     </div>
  //   );
  // };
  render() {
    // const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.match.params.appId] && this.props.currentBranch[this.props.match.params.appId].branchId
    const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion;
    const canEditBpmn = currentVersion && (this.props.orgPermissions.includes('bpmn.Edit') || this.props.appPermissions.includes('bpmn.Edit'))
    const canCreateBpmn = currentVersion && (this.props.orgPermissions.includes('bpmn.Create') || this.props.appPermissions.includes('bpmn.Create'))
    const canDeleteBpmn = currentVersion && (this.props.orgPermissions.includes('bpmn.Delete') || this.props.appPermissions.includes('bpmn.Delete'))
    const canViewBpmn = this.props.orgPermissions.includes('bpmn.View') || this.props.appPermissions.includes('bpmn.View')

    const columns: any = [
      {
        title: "Name",
        dataIndex: "bpmnName",
        key: "bpmnName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Org Name",
        dataIndex: "orgName",
        key: "orgName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      }
    ];

    if (currentVersion) {
      columns.push(
        {
          title: "Action",
          key: "action",
          render: (text: any, record: any) => (
            <span>
              <span data-test-id="action_edit"
                className="action-icon edit-icon"
                title="Edit"
                onClick={e => {
                  if (this.props.guideVisible) {
                    return;
                  }
                  e.stopPropagation();
                  if (canEditBpmn) {
                    this.setState({
                      editvisible: true,
                      editType: "journey",
                      editInitialData: record,
                      editable: true
                    });
                    this.setState({
                      [record.bpmnId]: false
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to edit this Journey'
                    })
                  }
                }}
              >
                <TableEdit height='15px' width='15px' />
              </span>
              <span
                data-test-id="action_delete"
                className="action-icon delete-icon"
                title="Delete"
                onClick={e => {
                  if (this.props.guideVisible) {
                    return;
                  }
                  e.stopPropagation();
                  if (canDeleteBpmn) {
                    this.setState({
                      editType: "journey",
                      deleteData: record,
                      deleteVisible: true
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to delete this Journey'
                    })
                  }
                }}
              >
                <Delete style={{ width: "15px", height: "15px" }} />
              </span>
            </span>
          )
        }
      )
    }


    let soloColumns: any = [
      {
        title: "Name",
        key: "name",
        render: (text: any, record: any) => (
          <>
            {record.type === "public" ? <img style={{ marginBottom: "2px" }} alt="publicIcon" src={publicIcon} /> : <img style={{ marginBottom: "2px" }} alt="privateIcon" src={privateIcon} />} {record.name}
          </>
        )
      },
      {
        title: "Created By",
        dataIndex: "createdBy",
        key: "createdBy"
      },
      {
        title: "Created At",
        key: "createdAt",
        render: (text: any, record: any) => (
          moment(record.createdAt).local().format('YYYY-MM-DD HH:mm:ss')
        )
      },
      {
        title: "Updated At",
        key: "updatedAt",
        render: (text: any, record: any) => (
          record.updatedAt === null ? "-" : moment(record.updatedAt).local().format('YYYY-MM-DD HH:mm:ss')
        )
      }
    ];

    if (currentVersion) {
      soloColumns.push(
        {
          title: "Action",
          key: "action",
          render: (text: any, record: any) => (
            <span>
              <span data-test-id="action_edit"
                className="action-icon edit-icon"
                title="Edit"
                onClick={e => {
                  e.stopPropagation();
                  if (canEditBpmn) {
                    this.setState({
                      editvisible: true,
                      editType: "solo",
                      editable: true,
                      editSoloData: record,
                    });
                    this.setState({
                      [record.bpmnid]: false
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to edit this solo'
                    })
                  }
                }}
              >
                <TableEdit height='21px' width='21px' />
              </span>
              <span
                data-test-id="action_delete"
                className="action-icon delete-icon"
                title="Delete"
                onClick={e => {
                  e.stopPropagation();
                  if (canDeleteBpmn) {
                    this.setState({
                      deleteData: record,
                      editType: "solo",
                      deleteVisible: true
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to delete this Journey'
                    })
                  }
                }}
              >
                <Delete />
              </span>
            </span>
          )
        }
      )
    }

    const appId = this.props.match.params.appId
    let { BpmnLoading, BpmnList } = this.state;
    // let { soloList } = this.state;
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
    //const isRenderSolo = window.location.origin.includes("localhost") || window.location.origin.includes("testing");
    return (
      <>
        {canViewBpmn ?
          <div className='viewWrapper'>
            {
              !BpmnLoading ?
                (
                  <React.Fragment>
                    {
                      (BpmnList.length > 0) ?
                        (
                          <div className={"row " + style.data}>
                            <div className={style.header} >
                              <div className={style.first}>
                                <h4>Assisted</h4>
                                <h5>View, edit or create Journey diagrams</h5>
                              </div>
                              <div className={"flex " + style.first}>
                                <SearchBar
                                  ref={this.state.searchRef}
                                  data={BpmnList}
                                  columns={columns}
                                  onFilter={(filteredData ) => {
                                    this.setState({
                                      filteredData: filteredData,
                                    })
                                  }}
                                  onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                                />
                                {canCreateBpmn &&
                                  <Button 
                                    className={"tour_journey_creation_initial"} 
                                    dataTestId="create_journey" 
                                    size="small" 
                                    onClick={() => { 
                                      this.setState({ visible: true }); 
                                      this.props.selectedJourney(null);
                                      this.props.setStepIndex(this.props.onboardingInfo.stepIndex + 1)
                                    }}
                                  >
                                    CREATE JOURNEY
                                  </Button>
                                }
                              </div>
                            </div>
                            <div className={style.content}>
                              <Table
                                pagination={false}
                                scroll={{ y: 'calc(100vh - 240px)' }}
                                columns={columns}
                                onRow={(record: any, rowIndex: any) => {
                                  return {
                                    'data-test-id': 'bpmn_table_row_' + record.key,
                                    className: record.bpmnId === this.props.onboardingInfo.flowId ? "tour_journey_row_selection":"",
                                    onClick: () => {
                                      this.props.history.push(
                                        this.props.match.url +
                                        "/" +
                                        record.bpmnId +
                                        "/create"
                                      );
                                      if (record.bpmnId === this.props.onboardingInfo.flowId && this.props.guideVisible) {
                                        this.props.setStepIndex(this.props.onboardingInfo.stepIndex + 1);
                                      }
                                    },
                                  };
                                }}
                                data-test-id="bpmn_table"
                                className={"override-table-container"}
                                dataSource={this.state.filteredData.map((res, key) => {
                                  return { ...res, key: key };
                                })}
                              />
                            </div>
                          </div>
                        )
                        :
                        (
                          <NoData
                            svg={BpmIllustration}
                            header='Create Journey'
                            content='Create Journey diagram with graphical elements'
                            buttonCallback={(() => {
                              if (canCreateBpmn) {
                                this.setState({ visible: true })
                                this.props.selectedJourney(null)
                                this.props.setStepIndex(this.props.onboardingInfo.stepIndex + 1)
                              } else {
                                this.props.pushToast({
                                  type: 'error',
                                  message: 'You are not authorized to create Journeys'
                                })
                              }
                            })}
                            buttonClassName = "tour_journey_creation_initial"
                          />
                        )
                    }
                  </React.Fragment>
                )
                :
                (
                  <div className={style.loadingSpinner}>
                    <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                  </div>
                )
            }
            <FormModal
              data-test-id="form_modal"
              visible={this.state.visible}
              getBpmns={(guideVisible?: any) => this.getBpmns(this.props, guideVisible)}
              appId={appId}
              editType={this.state.editType}
              appVersion={this.props.appVersion}
              setvisible={status => this.setState({ visible: status })}
            ></FormModal>
            {this.state.editvisible && (
              <FormModal
                data-test-id="edit_form_modal"
                getBpmns={() => this.getBpmns(this.props)}
                visible={this.state.editable}
                editInitialData={this.state.editInitialData}
                editSoloData={this.state.editSoloData}
                appId={appId}
                appVersion={this.props.appVersion}
                editType={this.state.editType}
                setvisible={status => {
                  this.setState({ editable: status, editInitialData: {} });
                  setTimeout(() => {
                    this.setState({ editvisible: false });
                  }, 400);
                }}
                editable={this.state.editable}
              ></FormModal>
            )}
            {/* {(soloList.length > 0 || BpmnList.length > 0) && (currentBranchId !== null) && <React.Fragment>
              {<div className={"row " + style.data}>
                <div className={style.header}>
                  <div className={style.first}>
                    <h4>Solo</h4>
                    <h5>View, edit or create solo</h5>
                  </div>
                </div>
                <div className={style.content}>
                  <Table
                    pagination={false}
                    scroll={{ y: 'calc(100vh - 300px)' }}
                    columns={soloColumns}
                    onRow={(record: any, rowIndex: any) => {
                      return {
                        'data-test-id': 'bpmn_table_row_' + record.key,
                        onClick: () => {
                          this.props.selectedSolo(record);
                          this.props.history.push(
                            this.props.match.url +
                            "/solo/" +
                            record.id +
                            "/create"
                          );
                        },
                      };
                    }}
                    data-test-id="bpmn_table"
                    className={"override-table-container"}
                    dataSource={soloList.map((res, key) => {
                      return { ...res, key: key };
                    })}
                  />
                </div>
              </div>}
            </React.Fragment>} */}
            {/* {this.state.editType === "solo" ? <Modal
              dataTestId="delete_bpmn"
              id="deleteBpmn"
              unmountOnCancel={true}
              visible={this.state.deleteVisible}
              title="DELETE JOURNEY"
              onCancel={() => {
                this.setState({
                  deleteVisible: false,
                  deleteData: {}
                })
              }}
              deleteOptions={{
                type: "Bpmn",
                validateString: this.state.deleteData.name
              }}
              footer={{
                enable: true,
                okText: 'DELETE',
                cancelText: 'CANCEL',
                onOk: () => {
                  this.deleteSolo(this.state.deleteData.id)
                  this.setState({
                    deleteVisible: false
                  })
                }
              }}
            /> : */}
            {<Modal
              dataTestId="delete_bpmn"
              id="deleteBpmn"
              unmountOnCancel={true}
              visible={this.state.deleteVisible}
              title="DELETE JOURNEY"
              onCancel={() => {
                this.setState({
                  deleteVisible: false,
                  deleteData: {}
                })
              }}
              deleteOptions={{
                type: "Bpmn",
                validateString: this.state.deleteData.bpmnName
              }}
              footer={{
                enable: true,
                okText: 'DELETE',
                cancelText: 'CANCEL',
                onOk: () => {
                  this.deleteAssist(this.state.deleteData.bpmnId)
                  this.setState({
                    deleteVisible: false
                  })
                }
              }}
            />}
          </div>
          :
          <div className="viewWrapper">
            <NoData
              svg={WarningIcon}
              header='Not Authorized'
              content='Please request owner of this organization to provide access'
              noButton={true}
            />
          </div>}
      </>
    );
  }
}
interface FormmodelProps {
  appVersion?: { currentVersion: boolean, versionId: string };
  visible: boolean;
  getBpmns?: () => void;
  getSolo?: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  editInitialData?: {};
  editSoloData?: {};
  editable?: boolean;
  editType: string;
}
let onSubmit: any;
const FormModal = ({
  visible,
  getBpmns,
  getSolo,
  setvisible,
  editType,
  appId,
  appVersion,
  editInitialData,
  editSoloData,
  editable,
}: FormmodelProps) => {
  return (
    <Modal
      id="createEditBpmn"
      dataTestId="created_edit_bpmn"
      title={editInitialData ? 'EDIT JOURNEY' : 'CREATE JOURNEY'}
      visible={visible}
      className='common_modal'
      onCancel={() => {
        setvisible(false);
      }}
      unmountOnCancel={true}
      footer={{
        enable: false
      }}
    >
      <Bpmn
        appVersion={appVersion}
        setvisible={setvisible}
        appId={appId}
        getSolo={getSolo}
        getBpmns={getBpmns}
        editType={editType}
        editInitialData={editInitialData}
        editSoloData={editSoloData}
        onSubmit={(submit: any) => (onSubmit = submit)}
        editable={editable}
        okText= {editable ? "SAVE" : "CREATE"}
        cancelText= {"CANCEL"}
        onCancel={() => {
          setvisible(false);
        }}
        onOk = {()=>{onSubmit()}}
      ></Bpmn>
    </Modal>
  );
};

const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appVersion: state.apps.appVersion[params['appId']],
    currentBranch: state.apps.appBranch,
    orgPermissions: state.org.orgPermissions,
    appPermissions: state.apps.selectedApp.permissions,
    onboardingInfo: state.onboarding.info,
    guideVisible: state.onboarding.guideVisible
  }
};

export default connect(
  mapStateToProps,
  { deleteForm, pushToast, selectedSolo, selectedJourney, setStepIndex, setGuideVisible }
)(FormsList);
